<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <priceListAdminAction v-if="showStatus" ref="priceListAdminAction" @drawerCancel="drawerCancel" :actionData="actionData">
            </priceListAdminAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch v-if="pageShowData.jurHead" @searchData="searchData" :flagList="[]" @openSearchs="openSearch" :getRequestData=getRequestData :searchList="pageShowData.jurHead.jurconfigform">
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                      highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'datetime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'formatter'">{{ $common.getIsGsp(tableValye.formatterContent,
                     scope.row[tableValye.entityField]) }}</span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import indexJs from './index';

import priceListAdminAction from "@/components/priceListAdminAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        priceListAdminAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },

            buttonList: [],
            pageShowData: [],
            formDataList: [],
            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            sField: "",
            parentSearchData: {},
            DialogVisible: false,
            seType: '',
            smId: '',
            showStatus: false,
            actionData: {},
            importShow: false,
            importType: "",
            url: "",
            multipleSelection: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false;
            commitData && this.getDataList();
        },
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 动作集合
        actionSet(actionData) {

            switch (actionData.actionType) {
                case 1:
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    this.showStatus = true;
                    break;
                case 2:
                    if (this.multipleSelection.length != 1) {
                        return this.$message.error("请先勾选一条数据")
                    }
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: this.multipleSelection[0],
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    this.showStatus = true;
                    break;
                case 3:
                    this.delDataAction()
                    break;
                case 4:
                    this.submitDataAction()
                    break;
                case 5:
                    this.importDetails()
                    break;
                case 6:
                    this.exportTemplate()
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            this.getDataList()
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/supriceList/importTemplate`
        },
        importDetails() {
            this.importType = 'supriceListexportReturnDetail'
            this.url = 'supriceList/exportReturnDetail'
            this.importShow = true
        },
        // 提交审核
        async submitDataAction() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            var delData = {
                ids: this.multipleSelection.map(item => item.id),
            };
            let responseData = await this.$http.supriceListsubmit(delData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "操作成功",
                });

                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.supriceListqueryList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list)
                this.returnData.total = responseData.result.total
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 删除数据
        delDataAction() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: this.multipleSelection.map(item => item.id)
                }
                let responseData = await this.$http.supriceListdelete(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })

        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

/* .el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
} */
</style>